<script setup>
    import { loadStripe } from "@stripe/stripe-js";
    import { fetchWithAuth } from "../../utils/authFetch";
    import { useAuthStore } from "../../utils/authStore";
    import Loader from "../Parts/Loader.vue";
</script>
<template>
    <Loader v-if="(!stripeLoaded) || showLoader" />
    <div v-if="!paymentSent && orderId" :class="{hidden:!stripeLoaded}">

        <form @submit.prevent="pay" >
            <div id="payment-element"></div>
            <button id="submit" class="btn btn-success">Pay</button>
        </form>
        <p v-if="paymentError" class="error">{{ paymentError }}</p>
    </div>
    <hr />
    <!--<button @click="ToggleLoader" class="btn btn-info">Toggle Loader</button>-->
</template>

<script>
    import { mapState } from 'pinia';

    const stripePublicKey = import.meta.env.VITE_STRIPE_PUBLIC_KEY;

        
    export default {
        props: {
            orderId: Number,
            onPaymentSent: Function
        },
        data() {
            return {
                stripe: null,
                elements: null,
                clientSecret: "",
                paymentError: "",
                connection: null, // SignalR connection
                paymentSent: false,
                stripeLoaded: false,
                showLoader: false
            };
        },
        async mounted() {
            this.startStripe();
        },
        computed: {
            ...mapState(useAuthStore, ['user']),
            isAdmin() {
                return this.user?.roles?.includes("Admin");
            }
        },
        beforeUnmount() {
            try {
                const stripeElement = this.elements?.getElement('payment');
                if (stripeElement) {
                    stripeElement.unmount();
                    console.log('Stripe payment element unmounted');
                }
            } catch (err) {
                console.warn('Failed to unmount Stripe element:', err);
            }

            this.elements = null;
            this.stripe = null;
            this.stripeLoaded = false;
        },
        methods: {            
            async startStripe() {

                this.stripe = await loadStripe(stripePublicKey);


                const createPaymentForOrder = {
                    orderId: this.orderId
                };
                // Request PaymentIntent and create an order in backend
                const response = await fetchWithAuth("/payments/create-payment", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(createPaymentForOrder),
                });
                const { clientSecret, orderId } = await response.json(); // Expecting orderId from backend
                this.clientSecret = clientSecret;

                if (this.orderId != orderId) {
                    alert("OrderId didnt match?");
                }

                this.elements = this.stripe.elements({
                    clientSecret: this.clientSecret,
                    appearance: {
                        theme: "night",
                        variables: {
                            colorPrimary: "#840b9d",
                            colorBackground: "#1a1a1a",
                            colorText: "#ffffff",
                            colorDanger: "#ff4d4d",
                            fontFamily: "Arial, sans-serif",
                            spacingUnit: "5px",
                            borderRadius: "10px",
                        },
                        rules: {
                            ".Input": {
                                backgroundColor: "#2a2a2a",
                                color: "#ffffff",
                                borderRadius: "8px",
                                border: "1px solid #555",
                                padding: "10px",
                            },
                            ".Label": { color: "#dddddd" },
                            ".Error": { color: "#ff4d4d" },
                        }
                    }
                });

                const paymentElement = this.elements.create("payment");
                paymentElement.mount("#payment-element");
                this.stripeLoaded = true;
            },
            async pay() {
                if (!this.stripe || !this.elements) {
                    this.paymentError = "Stripe is not initialized.";
                    return;
                }

                const { error, paymentIntent } = await this.stripe.confirmPayment({
                    elements: this.elements,
                    redirect: "if_required",
                });

                if (error) {
                    this.paymentError = error.message;
                }
                else {
                    this.paymentSent = true;
                    var paymentSent = this.paymentSent;
                    this.onPaymentSent(paymentSent);
                }
            },
            async ToggleLoader() {
                this.showLoader = !this.showLoader;
            }
        }
    };
</script>

<style scoped>
    #error {
        color: #ff4d4d;
        margin-top: 10px;
    }

    #payment-element {
        margin-bottom: 20px;
    }

</style>
